const cms: any = {
    menu: /cms:*/,
    contract: 'cms:contract',
    contract_attachments: 'cms:contract_attachments',
    deliverable: 'cms:deliverable',
    calendar: 'cms:calendar',
    report: 'cms:report'
}

export default cms